export default {
    apiKey: "AIzaSyAG7Ojy3MjwEuwccqEZS-9qiqptwZ9zu4I",
    authDomain: "herbartapp-2e9ca.firebaseapp.com",
    databaseURL: "https://herbartapp-2e9ca.firebaseio.com",
    projectId: "herbartapp-2e9ca",
    storageBucket: "herbartapp-2e9ca.appspot.com",
    messagingSenderId: "939370896758"
  };
